var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-container"},[_c('div',{on:{"click":_vm.openMenu}},[_vm._t("click")],2),_c('portal',{attrs:{"to":"portal-menu"}},[(_vm.show)?_c('div',{staticClass:"menu",style:(_vm.menuStyle)},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }